import alterationsReducer from './alterations';

export default alterationsReducer;
